import classnames from 'classnames';

export const themes = {
  default: ({ color, hasMenus, isBrowserGreaterThan, isExpand }) => ({
    thRoot: 'bg-gray-darker image-responsive-cell relative',
    thThumbnail:
      'focus:opacity-75 hover:opacity-75 focus:scale-105 hover:scale-105 transition-transform-opacity',
    thBody: classnames(
      `md:absolute bg-${color} md:overflow-hidden text-white transition-heights w-full`,
      {
        'h-full p-2 bottom-0 opacity-85': isBrowserGreaterThan.S,
      },
    ),
    thBodyStyle: isBrowserGreaterThan.S && !isExpand ? { height: '4.8rem' } : null,
    thLabel: classnames('reset-heading text-white no-underline', {
      'h-full': !hasMenus,
      'p-2': !isBrowserGreaterThan.S,
      'text-base': !isBrowserGreaterThan.XS,
      'text-md': isBrowserGreaterThan.XS && !isBrowserGreaterThan.S,
      'p-0 overflow-hidden text-xl': isBrowserGreaterThan.S,
    }),
    thLabelStyle: isBrowserGreaterThan.S ? { minHeight: 0 } : { minHeight: '3.75rem' },
    thMenus: classnames('reset-list hidden md:block transition-opacity', {
      'opacity-0': !isExpand,
      'opacity-100': isExpand,
    }),
    thMenu: 'text-base text-white focus:underline hover:underline',
  }),
};
